import { render, staticRenderFns } from "./JobSocial.vue?vue&type=template&id=7d89f4cb&"
import script from "./JobSocial.vue?vue&type=script&lang=js&"
export * from "./JobSocial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports